import { getActiveMenu } from './getActiveMenu';

export const updateMenuChanges = async (message, reducers, data, connection) => {
  const { placeId } = message.payload;
  const { placeDispatch } = reducers;
  console.log('GETING ACTIVE MENU FOR EVENTS ...');
  const payload = await getActiveMenu(placeId);
  placeDispatch({ type: 'LOAD_MENU', payload });
};